export const Error = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="black" strokeWidth="2"/>
        <path d="M6 6L18.5 18.5" stroke="black" strokeWidth="2"/>
        </svg>
    );
  };